import type { ArticleQuantityState, Enums } from "../types";

/**
 * This function returns the color for the given article quantity state.
 */
export function getArticleQuantityStateColor(state: ArticleQuantityState): Enums<"color"> {
	switch (state) {
		case "ok":
			return "emerald";
		case "low":
			return "amber";
		case "critical":
			return "red";
		case "empty":
			return "gray";
	}
}
